<script>
export default {
  name: 'SliderWithInput',
  functional: true,
  render: function (h, { props, parent, children, listeners, data, ...args }) {
    const { name, value, min, max, type, showLabel, step, onStepClick } = props;
    
    const stepValue = step === undefined ? 1 : step; 
    const { staticClass } = data
    const change = listeners.change
    const getSlot = key => children && children.find(el => el.data && el.data.slot === key)
    const slider = getSlot('slider')
    const after = getSlot('after')
    const isCCT = type === 'UIControl_ColorTemperature' //是否色温 色温调整步进为100
    const isBrightness = type === 'UIControl_Bright' //是否亮度 色温调整步进为10%
    const isBindTiMuPlaybackSpeed = type === 'UIControl_TianMu_PlaybackSpeed' || type === 'UIControl_TianMu_PlaybackSpeed_Group'; //是否倍速 倍速调整步进为0.1
    //百分10的步进调整
    const clickAdd = add => {
      debugger
      if (listeners.onStepClick) {
        listeners.onStepClick(add);
        return
      }

      if (isCCT || isBrightness || isBindTiMuPlaybackSpeed) {
        let step = isCCT ? 100 : isBrightness ? 10 : 0.1
         let currentValue = parseFloat(value) || 0
        if (add) {
          let newValue = currentValue + step
          change(Math.min(parseFloat(newValue.toFixed(2)), max))
        } else {
          let newValue = currentValue - step
          change(Math.max(parseFloat(newValue.toFixed(2)), min))
        }
        return
      }

      const step = Math.ceil((max - min) / 10)

      const allValues = Array.from(Array(Math.ceil((max - min) / step) + 1).keys()).map(i => i * step + min)
      
      const currentStep = allValues.findIndex(i => i >= value);

      if (add) {
        const val = allValues[currentStep + 1] ? Math.min(allValues[currentStep + 1], max) : max;
        // const step1 = Math.floor(value / step) // 向下去整
        // change(Math.min((step1 + 1) * step + min, max))
        change(val);
      } else {
         const val = allValues[currentStep - 1] ? Math.max(allValues[currentStep - 1], min) : min;
        // const step1 = Math.ceil(value / step) // 向下去整
        // change(Math.max((step1 - 1) * step, min))
        change(val);
      }
    }
    const changeFunc = value => {
      change(value)
      //修复:针对于el-slider 上面的tooltip不消失的问题
      const ref = 'elSlider'
      if (parent.$refs[ref]) {
        setTimeout(() => {
          parent.$refs[ref] && parent.$refs[ref].$refs['button1'] && parent.$refs[ref].$refs['button1'].handleMouseLeave()
        }, 500)
      }
    }
    return (
      <div class={`sliderInput ${data.class}`}>
        {name && showLabel && <span class="scence_ctr_span_title">{name}</span>}
        <div class={'scence_ctr_div_slider'}>
          <img
            class={'blueIcon'}
            onClick={() => {
              clickAdd(false)
            }}
            src={require('@/assets/img/add.png')}
          />
          {getSlot('start')}
          <div class={'sevice_slider_new ' + (slider ? slider.data.staticClass : '')}>
            <el-slider onInput={changeFunc} value={value} min={min} max={max} class={staticClass} step={stepValue} ref="elSlider" />
            {slider && slider.children}
          </div>
          {getSlot('end')}
          <img
            class={'blueIcon blueIcon1'}
            onClick={() => {
              clickAdd(true)
            }}
            src={require('@/assets/img/reduce.png')}
          />
          <el-input-number class="input_number_action" min={min} max={max} onChange={change} value={value} style="width: 60px;" />
          {after}
          {/** 占位*/}
          {!after && (
            <span class="lightUnit" style="margin-left: 4px; visibility: hidden; ">
              {'%'}
            </span>
          )}
        </div>
      </div>
    )
  },
}
</script>

<style lang="scss" scoped>
@import '~@/components/button/comps-button.scss';

.sevice_slider_new {
  flex: 1;
}

.blueIcon {
  color: #6094fc;
  margin-right: 10px;
  cursor: pointer;
  width: 25px;
  height: 25px;
}

.blueIcon1 {
  margin-left: 10px;
  margin-right: 0px;
}
</style>
